import { IPopupService } from "./interfaces";
import { injectable} from 'inversify';
import { Subject } from 'rxjs';
import { EModalType } from "../common/enum/EModalType";

@injectable()
export default class PopupService implements IPopupService {
    notifyVisibility: Subject<Object> = new Subject<Object>();
    showModal(config) {
        this.notifyVisibility.next({isVisible:true, ...config});
    }

    showAlert(config:{title:string, content: string, closeEvent: any}){
        this.showModal({ ...config, modalType: EModalType.ALERT});
    }

    showConfirmation(config:{title:string, content: string, closeEvent: any, okButtonClick:any}){
        this.showModal({ ...config, modalType: EModalType.CONFIRMATION});
    }

    hideModal() {
        this.notifyVisibility.next({isVisible: false});
    }
}